import React, { useState, useEffect } from 'react'
import { Box, Flex, Button } from '@mantine/core'
import { useSelector } from 'react-redux'
import { UserGeneralFormProvider } from './hook/user-general-form'
import { useFormUserGeneral } from './schema/form'
import UserInformation from './section/UserInformation'
import UserMarkingCode from './section/UserMarkingCode'
import UserChangePassword from './section/UserChangePassword'
import { updateUser } from '../../../../../services/users'
import { notificationError, notificationSuccess } from '../../../../ui/Notifications'
import { useDispatch } from 'react-redux'
import { getUserDetail } from '../../../../../store/userDetail'
import { useParams } from 'react-router-dom'

const defaultSurveyList = {
  'Did not choose': '0',
  'Search Engine (Google,etc.)': '1',
  'Referral': '2',
  'Email Newsletter': '3',
  'WhatsApp or Broadcast': '4',
  'Telegram': '5',
  'Facebook': '6',
  'Instagram': '7',
  'LinkedIn': '8',
  'Youtube': '9',
  'Other (please specify)': '10'
}

const UserGeneral = () => {
  const params = useParams()
  const userId = params.id
  const { isLoadingUser, general } = useSelector(state => state.user_detail)
  const form = useFormUserGeneral()

  const dispatch = useDispatch()
  const [loadingForm, setLoadingForm] = useState(false)

  const handleSubmitGeneralUser = async (formData) => {
    setLoadingForm(true)
    const payload = {
      ...formData,
    }

    const recentMarkingCode = general.markingCode
    const updateMarkingCode = formData.marking_codes

    const remapMarkingCode = updateMarkingCode.map((value) => {
      const findData = recentMarkingCode.find((val) => val.code === value)
      if (findData) {
        return {
          id: findData.id,
          code: value,
          user_id: findData.user_id
        }
      } else {
        return {
          code: value,
        }
      }
    })

    payload.marking_codes = remapMarkingCode

    try {
      const response =await updateUser(userId, payload)
      if (response.success) {
        setLoadingForm(false)
        notificationSuccess('Update User Success', 'You have been updated data user')
        dispatch(getUserDetail(userId))
      }
    } catch (error) {
      setLoadingForm(false)
      let errorDescriptionMessage = 'There is an error while updating user'
      const errorMessage = error?.response?.data?.message
      if (errorMessage.includes('email')) {
        form.setFieldError('email', 'Email already exists')
        const errorEmail = {
          email: 'Email already exists'
        }
        handlingScrolledError(errorEmail)
        errorDescriptionMessage = 'Please recheck your form'
      }
      notificationError('Update User Error', errorDescriptionMessage)
    }
  }

  const handlingScrolledError = (error) => {
    const errorField = Object.keys(error)[0]
    if (errorField) {
      const inputNode = form.getInputNode(errorField)
      if (inputNode) {
        inputNode.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }

  useEffect(() => {
    if (!isLoadingUser) {
      handleSetForm(general)
    }
    // eslint-disable-next-line
  }, [isLoadingUser, general])

  const handleSetForm = (data) => {
    const dataForm = {
      name: data.fullName,
      email: data.email,
      phone: data.phone,
      active: data.active ? 'true' : 'false',
      country_signup: data.countrySignup ? `${data.countrySignup}` : null,
      city_signup: data.citySignup ? `${data.citySignup}` : null,
      referral_code: data.referralCode || '',
      survey: defaultSurveyList[data.survey],
      can_order: data.canOrder,
      marking_codes: data.markingCode.length > 0 ? data.markingCode.map((value) => value.code) : []
    }

    form.initialize(dataForm)
    form.setValues(dataForm)
  }

  return (
    <Box>
      <UserGeneralFormProvider form={form}>
        <UserInformation />

        <UserMarkingCode />

        <UserChangePassword />

      </UserGeneralFormProvider>

      <Box mt='xl'>
        <Flex justify='flex-end'>
          <Button
            size='xs'
            loading={loadingForm}
            variant="filled"
            onClick={form.onSubmit((value) => { handleSubmitGeneralUser(value) }, (error) => { handlingScrolledError(error) })}
            >
              Update
            </Button>
        </Flex>
      </Box>
    </Box>
  )
}

export default UserGeneral